import { AddressFormKeys } from 'components/AddressFormFields/constants'

export const OperationalPrefix = 'operational'

export const RegisteredBusinessAddressFormKeys = {
  ...AddressFormKeys,
} as const

export const OperationalBusinessAddressFormKeys = {
  OPERATIONAL_ADDRESS_1: `${OperationalPrefix}${AddressFormKeys.ADDRESS_1}`,
  OPERATIONAL_ADDRESS_2: `${OperationalPrefix}${AddressFormKeys.ADDRESS_2}`,
  OPERATIONAL_CITY: `${OperationalPrefix}${AddressFormKeys.CITY}`,
  OPERATIONAL_POSTAL_CODE: `${OperationalPrefix}${AddressFormKeys.POSTAL_CODE}`,
  OPERATIONAL_COUNTRY_CODE: `${OperationalPrefix}${AddressFormKeys.COUNTRY_CODE}`,
  OPERATIONAL_COUNTRY_STATE_CODE: `${OperationalPrefix}${AddressFormKeys.COUNTRY_STATE_CODE}`,
} as const

export const BusinessAddressFormKeys = {
  ...RegisteredBusinessAddressFormKeys,
  ...OperationalBusinessAddressFormKeys,
  IS_OPERATIONAL_DIFFERENT: 'isOperationalDifferent',
} as const
